"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-six/sections/headerSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeaderSectionSupport3sItem = {
    key: Key | null | undefined;
    /** Detected variants: "support-item mb-3" | "support-item" */
    className: string;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    i0ClassName: string;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    h50Text: ReactNode;
    /** Detected variants: "General Inquiries" | "Emergency Cases" */
    p0Text: ReactNode;
    /** Detected variants: "avatar avatar-lg bg-primary rounded-circle" */
    div0ClassName?: string;
    /** Detected variants: "link" */
    h50ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
};

type HeaderSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeSixHeaderSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLAnchorElement>;
    divDiv1H50H5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionSupport3sItem) => Partial<ComponentProps<"h5">>);
    /** Default: "#" */
    headerDiv0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    headerDiv0Nav0Div0Link0LinkId?: string;
    headerDiv0Nav0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home6" */
    headerDiv0Nav0Div0Link1LinkHref?: string;
    headerDiv0Nav0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-06.svg" */
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "all_routes.home6" */
    headerDiv0Nav0Div1Div0Div0Link0LinkHref?: string;
    headerDiv0Nav0Div1Div0Div0Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-06.svg" */
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageSrc?: string;
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    headerDiv0Nav0Div1Div0Div0Link1LinkHref?: string;
    /** Default: "menu_close" */
    headerDiv0Nav0Div1Div0Div0Link1LinkId?: string;
    headerDiv0Nav0Div1Div0Div0Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Contact Information" */
    headerDiv0Nav0Div1Div0Div1Div0H30H3Text?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div0H30H3Visible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Follow Us" */
    headerDiv0Nav0Div1Div0Div1Div1H30H3Text?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div1H30H3Visible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.login" */
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkHref?: string;
    /** Default: "Sign In" */
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkText?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.register" */
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkHref?: string;
    /** Default: "Sign Up" */
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkText?: ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkVisible?: boolean;
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.booking" */
    headerDiv0Nav0Ul0Li0Link0LinkHref?: string;
    headerDiv0Nav0Ul0Li0Link0LinkVisible?: boolean;
    headerDiv0Nav0Ul0Li0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerDiv0Nav0Ul0Li0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Book Appointment" */
    headerDiv0Nav0Ul0Li0Link0Span1SpanText?: ReactNode;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    headerSectionSupport3s: HeaderSectionSupport3sItem[];
    headerSectionUls: HeaderSectionUlsItem[];
    headerSectionSupport3sItemWrapper?: (item: HeaderSectionSupport3sItem, content: ReactNode) => ReactNode;
    headerSectionSupport3sRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionSupport3sH5Visible?: boolean;
    headerSectionSupport3sH5Renderer?: (item: HeaderSectionSupport3sItem, defaultNode: ReactNode) => ReactNode;
    headerSectionSupport3sH5Props?: Partial<ComponentProps<"h5">> | ((item: HeaderSectionSupport3sItem) => Partial<ComponentProps<"h5">>);
    headerSectionUlsItemWrapper?: (item: HeaderSectionUlsItem, content: ReactNode) => ReactNode;
    headerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    headerSectionUlsLinkVisible?: boolean;
    headerSectionUlsLinkRenderer?: (item: HeaderSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    headerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeaderSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeSixHeaderSectionGenerated: FC<HomeSixHeaderSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    headerDiv0Nav0Div0Link0LinkHref = "#",
    headerDiv0Nav0Div0Link0LinkId = "mobile_btn",
    headerDiv0Nav0Div0Link0LinkVisible,
    headerDiv0Nav0Div0Link0LinkRenderer,
    headerDiv0Nav0Div0Link0LinkProps,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-06.svg",
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div0Link1LinkHref = "all_routes.home6",
    headerDiv0Nav0Div0Link1LinkVisible,
    headerDiv0Nav0Div0Link1LinkRenderer,
    headerDiv0Nav0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-06.svg",
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageVisible,
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageRenderer,
    headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageProps,
    headerDiv0Nav0Div1Div0Div0Link0LinkHref = "all_routes.home6",
    headerDiv0Nav0Div1Div0Div0Link0LinkVisible,
    headerDiv0Nav0Div1Div0Div0Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Div0Link0LinkProps,
    headerDiv0Nav0Div1Div0Div0Link1LinkHref = "#",
    headerDiv0Nav0Div1Div0Div0Link1LinkId = "menu_close",
    headerDiv0Nav0Div1Div0Div0Link1LinkVisible,
    headerDiv0Nav0Div1Div0Div0Link1LinkRenderer,
    headerDiv0Nav0Div1Div0Div0Link1LinkProps,
    headerDiv0Nav0Div1Div0Div1Div0H30H3Text = "Contact Information",
    headerDiv0Nav0Div1Div0Div1Div0H30H3Visible,
    headerDiv0Nav0Div1Div0Div1Div0H30H3Renderer,
    headerDiv0Nav0Div1Div0Div1Div0H30H3Props,
    headerDiv0Nav0Div1Div0Div1Div1H30H3Text = "Follow Us",
    headerDiv0Nav0Div1Div0Div1Div1H30H3Visible,
    headerDiv0Nav0Div1Div0Div1Div1H30H3Renderer,
    headerDiv0Nav0Div1Div0Div1Div1H30H3Props,
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkHref = "all_routes.login",
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkText = "Sign In",
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkVisible,
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkRenderer,
    headerDiv0Nav0Div1Div0Div1Div2Link0LinkProps,
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkHref = "all_routes.register",
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkText = "Sign Up",
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkVisible,
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkRenderer,
    headerDiv0Nav0Div1Div0Div1Div2Link1LinkProps,
    headerDiv0Nav0Ul0Li0Link0LinkHref = "all_routes.booking",
    headerDiv0Nav0Ul0Li0Link0LinkVisible,
    headerDiv0Nav0Ul0Li0Link0LinkRenderer,
    headerDiv0Nav0Ul0Li0Link0LinkProps,
    headerDiv0Nav0Ul0Li0Link0Span1SpanText = "Book Appointment",
    divDiv1H50H5Props,
    liLink0LinkProps,
    headerSectionSupport3s,
    headerSectionUls,
    headerSectionSupport3sItemWrapper,
    headerSectionSupport3sRenderer,
    headerSectionSupport3sH5Visible,
    headerSectionSupport3sH5Renderer,
    headerSectionSupport3sH5Props,
    headerSectionUlsItemWrapper,
    headerSectionUlsRenderer,
    headerSectionUlsLinkVisible,
    headerSectionUlsLinkRenderer,
    headerSectionUlsLinkProps,
}) => {
    return (
        <header className={isScrolled ? "header header-six fixed" : "header header-six"}>
            <div className="container">
                <nav className="navbar navbar-expand-lg header-nav">
                    <div className="navbar-header">
                        {renderNode(headerDiv0Nav0Div0Link0LinkVisible, headerDiv0Nav0Div0Link0LinkRenderer, (
                            <SmartLink id={headerDiv0Nav0Div0Link0LinkId} href={headerDiv0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(headerDiv0Nav0Div0Link0LinkProps ?? {})}>
                                <i className="fa-solid fa-bars" />
                            </SmartLink>
                        ))}
                        {renderNode(headerDiv0Nav0Div0Link1LinkVisible, headerDiv0Nav0Div0Link1LinkRenderer, (
                            <SmartLink href={headerDiv0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(headerDiv0Nav0Div0Link1LinkProps ?? {})}>
                                {renderNode(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageVisible, headerDiv0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </SmartLink>
                        ))}
                    </div>
                    <div className="header-menu">
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                {renderNode(headerDiv0Nav0Div1Div0Div0Link0LinkVisible, headerDiv0Nav0Div1Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={headerDiv0Nav0Div1Div0Div0Link0LinkHref} className="menu-logo" {...(headerDiv0Nav0Div1Div0Div0Link0LinkProps ?? {})}>
                                        {renderNode(headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageVisible, headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageAlt} {...(headerDiv0Nav0Div1Div0Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </SmartLink>
                                ))}
                                {renderNode(headerDiv0Nav0Div1Div0Div0Link1LinkVisible, headerDiv0Nav0Div1Div0Div0Link1LinkRenderer, (
                                    <SmartLink id={headerDiv0Nav0Div1Div0Div0Link1LinkId} className="menu-close" href={headerDiv0Nav0Div1Div0Div0Link1LinkHref} onClick={onMenuClose} {...(headerDiv0Nav0Div1Div0Div0Link1LinkProps ?? {})}>
                                        <i className="fas fa-times" />
                                    </SmartLink>
                                ))}
                            </div>
                            <HeaderNav menus={menus} />
                            <div className="header-items">
                                <div className="about-popup-item border-0 pb-0">
                                    {renderNode(headerDiv0Nav0Div1Div0Div1Div0H30H3Visible, headerDiv0Nav0Div1Div0Div1Div0H30H3Renderer, (
                                        <h3 className="title" {...(headerDiv0Nav0Div1Div0Div1Div0H30H3Props ?? {})}>{headerDiv0Nav0Div1Div0Div1Div0H30H3Text}</h3>
                                    ))}
                                    {renderCollectionNode(
                                        headerSectionSupport3s,
                                        (item: HeaderSectionSupport3sItem) => (
                                            <div className={item.className} key={item.key}>
                                                <div className={item.div0ClassName ?? "avatar avatar-lg bg-primary rounded-circle"}>
                                                    <i className={item.i0ClassName} />
                                                </div>
                                                <div>
                                                    <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                    {renderItemNode(headerSectionSupport3sH5Visible, headerSectionSupport3sH5Renderer, item, (
                                                        <h5 className={item.h50ClassName ?? "link"} {...(typeof headerSectionSupport3sH5Props === "function" ? headerSectionSupport3sH5Props(item) : (headerSectionSupport3sH5Props ?? {}))} {...(typeof divDiv1H50H5Props === "function" ? divDiv1H50H5Props(item) : (divDiv1H50H5Props ?? {}))}>{item.h50Text}</h5>
                                                    ))}
                                                </div>
                                            </div>
                                        ),
                                        headerSectionSupport3sItemWrapper,
                                        headerSectionSupport3sRenderer
                                    )}
                                </div>
                                <div className="about-popup-item border-0 pb-0">
                                    {renderNode(headerDiv0Nav0Div1Div0Div1Div1H30H3Visible, headerDiv0Nav0Div1Div0Div1Div1H30H3Renderer, (
                                        <h3 className="title" {...(headerDiv0Nav0Div1Div0Div1Div1H30H3Props ?? {})}>{headerDiv0Nav0Div1Div0Div1Div1H30H3Text}</h3>
                                    ))}
                                    <ul className="d-flex align-items-center gap-2 social-iyem">
                                        {renderCollectionNode(
                                            headerSectionUls,
                                            (item: HeaderSectionUlsItem) => (
                                                <li key={item.key}>
                                                    {renderItemNode(headerSectionUlsLinkVisible, headerSectionUlsLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} {...(typeof headerSectionUlsLinkProps === "function" ? headerSectionUlsLinkProps(item) : (headerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                            <i className={item.className} />
                                                        </SmartLink>
                                                    ))}
                                                </li>
                                            ),
                                            headerSectionUlsItemWrapper,
                                            headerSectionUlsRenderer
                                        )}
                                    </ul>
                                </div>
                                <div className="header-items-button">
                                    {renderNode(headerDiv0Nav0Div1Div0Div1Div2Link0LinkVisible, headerDiv0Nav0Div1Div0Div1Div2Link0LinkRenderer, (
                                        <SmartLink href={headerDiv0Nav0Div1Div0Div1Div2Link0LinkHref} className="btn btn-primary btn-primary-gradient" {...(headerDiv0Nav0Div1Div0Div1Div2Link0LinkProps ?? {})}>
                                            <i className="isax isax-lock-1 me-2" />
                                            {headerDiv0Nav0Div1Div0Div1Div2Link0LinkText}
                                        </SmartLink>
                                    ))}
                                    {renderNode(headerDiv0Nav0Div1Div0Div1Div2Link1LinkVisible, headerDiv0Nav0Div1Div0Div1Div2Link1LinkRenderer, (
                                        <SmartLink href={headerDiv0Nav0Div1Div0Div1Div2Link1LinkHref} className="btn btn-dark" {...(headerDiv0Nav0Div1Div0Div1Div2Link1LinkProps ?? {})}>
                                            <i className="isax isax-user-tick4 me-2" />
                                            {headerDiv0Nav0Div1Div0Div1Div2Link1LinkText}
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ul className="nav header-navbar-rht">
                        <li>
                            {renderNode(headerDiv0Nav0Ul0Li0Link0LinkVisible, headerDiv0Nav0Ul0Li0Link0LinkRenderer, (
                                <SmartLink href={headerDiv0Nav0Ul0Li0Link0LinkHref} className="btn btn-primary theme-5-btn" {...(headerDiv0Nav0Ul0Li0Link0LinkProps ?? {})}>
                                    <span className="icon">
                                        <i className="isax isax-calendar-edit me-2" />
                                    </span>
                                    {" "}
                                    <span>{headerDiv0Nav0Ul0Li0Link0Span1SpanText}</span>
                                </SmartLink>
                            ))}
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default HomeSixHeaderSectionGenerated;
